import i18n from '../i18n';
import { routeSegments, reverseSegmentMap, Language, RouteKey, RouteParams } from './routeConfig';

export function localizedPath(
  routeKey: RouteKey,
  params?: RouteParams,
  lang?: Language
): string {
  const l = lang || (i18n.language as Language) || 'hu';
  const segs = routeSegments[l] || routeSegments.hu;

  let path: string;
  switch (routeKey) {
    case 'home':
      path = '/';
      break;
    case 'about':
      path = `/${segs.about}`;
      break;
    case 'services':
      path = `/${segs.services}`;
      break;
    case 'serviceDetail':
      path = `/${segs.services}/${params?.slug || ''}`;
      break;
    case 'caseStudies':
      path = `/${segs.services}/${params?.slug || ''}/${segs.caseStudies}`;
      break;
    case 'contact':
      path = `/${segs.contact}`;
      break;
    default:
      path = '/';
  }

  if (params?.query) {
    const search = new URLSearchParams(params.query).toString();
    if (search) path += `?${search}`;
  }

  return path;
}

export function detectLanguageFromPath(pathname: string): Language | null {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 0) return null;

  const first = segments[0];
  const match = reverseSegmentMap[first];
  return match ? match.lang : null;
}

export function translatePath(pathname: string, targetLang: Language): string {
  const [pathPart, queryPart] = pathname.split('?');
  const segments = pathPart.split('/').filter(Boolean);

  if (segments.length === 0) return pathname;

  const translated = segments.map((seg) => {
    const match = reverseSegmentMap[seg];
    if (match) {
      return routeSegments[targetLang][match.key];
    }
    // Not a translatable segment (e.g., a slug like "rehab") — keep as-is
    return seg;
  });

  let result = '/' + translated.join('/');
  if (queryPart) result += '?' + queryPart;
  return result;
}
